import Button from "components/CustomButtons/Button.js";
import React from "react";
import style from "./DonateButtonStyle";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(style);

const DonateButton = ({ buttonText }) => {
  const classes = useStyles();

  return (
    <div className={classes.buttonContainer}>
      <form
        action="https://www.paypal.com/donate"
        method="post"
        target="_top"
      >
        <input
          type="hidden"
          name="hosted_button_id"
          value={process.env.REACT_APP_PAYPAL_DONATION}
        />
        <Button className={classes.paypalButton} color="info" size="sm" type="submit" target="_top">
          {buttonText}
        </Button>
      </form>
    </div>
  );
};

export default DonateButton;